// Utilities
import { CompatiblePluginEventType } from "roosterjs";
/**
 * Plugin to handle keyboard events in the Rooster editor
 */ export class KeyboardEventPlugin {
    /**
     * Get the name of this plugin
     */ getName() {
        return "KeyboardEventPlugin";
    }
    /**
     * Initialize this plugin
     * @param editor The editor instance
     */ initialize(editor) {
        this.editor = editor;
    }
    /**
     * Dispose this plugin
     */ dispose() {
        this.editor = null;
    }
    /**
     * Handle editor events
     * @param event The plugin event
     */ onPluginEvent(event) {
        if (event.eventType === CompatiblePluginEventType.KeyDown && this.editor) {
            const keyboardEvent = event.rawEvent;
            // Check each registered keyboard handler
            for (const handler of this.keyboardHandlers){
                if (this.matchesKeyboardHandler(keyboardEvent, handler)) {
                    if (handler.preventDefault) {
                        keyboardEvent.preventDefault();
                        keyboardEvent.stopPropagation();
                    }
                    handler.handler(keyboardEvent, this.editor);
                    break; // Stop after first match
                }
            }
        }
    }
    /**
     * Check if the keyboard event matches the handler configuration
     */ matchesKeyboardHandler(event, handler) {
        const keyMatches = event.key === handler.key;
        const ctrlMatches = handler.ctrlKey === undefined || event.ctrlKey === handler.ctrlKey;
        const shiftMatches = handler.shiftKey === undefined || event.shiftKey === handler.shiftKey;
        const altMatches = handler.altKey === undefined || event.altKey === handler.altKey;
        return keyMatches && ctrlMatches && shiftMatches && altMatches;
    }
    /**
     * Constructor for KeyboardEventPlugin
     * @param keyboardHandlers Array of keyboard event handlers
     */ constructor(keyboardHandlers){
        this.editor = null;
        this.keyboardHandlers = keyboardHandlers;
    }
}
